module.exports = __webpack_public_path__ + "img/banner3_i.f2cd5334.png";